<template>
  <v-select
    v-model="internalValue"
    name="status_id"
    item-value="id"
    item-text="name"
    :items="statusesList"
    :readonly="readonly"
    v-bind="$attrs"
    v-on="listeners"
  >
    <template v-for="(slot, name) in $scopedSlots" v-slot:[name]="scope">
      <slot :name="name" v-bind="scope" />
    </template>
  </v-select>
</template>

<script>
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { mapActions } from 'vuex';
import { CREATE, EDIT, views } from '@/modules/_global/mixins/form-editable';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'OrderTransitionStatus',

  mixins: [i18nRefreshData],

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: [String, Number, Array],
      default: () => []
    },
    orderId: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: CREATE,
      validator: prop => views.includes(prop)
    }
  },

  data() {
    return {
      statusesList: []
    };
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.emitter(newValue);
      }
    },
    isEdit() {
      return this.action === EDIT;
    },
    listeners() {
      return {
        ...this.$listeners,
        change: this.emitter
      };
    }
  },

  watch: {
    orderId: {
      immediate: true,
      handler(v) {
        if (v !== null) {
          this.refreshData();
        }
      }
    }
  },

  created() {
    if (!this.isEdit) {
      this.refreshData();
    }
  },

  methods: {
    ...mapActions('order', ['getOrderTransitionStatuses']),
    ...mapCacheActions('order', ['getOrderStatuses']),

    refreshData() {
      this.getData().then(items => {
        this.statusesList = items;
      });
    },

    emitter(data) {
      this.$emit('change', data);
    },

    getData() {
      if (this.isEdit) {
        return this.getOrderTransitionStatuses(this.orderId).then(
          res => res.data.data
        );
      } else {
        return this.getOrderStatuses().then(res => res.data.data);
      }
    }
  }
};
</script>
